import { Position } from "./Rectangle.js";
import { UIElement } from "./UIElement.js";
import { scaleFont } from "./utils.js";
import "nanoid";
import "lodash";
import "./UIService.js";
import "../global-33d5eebf.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "../console/flags.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
const defaultStyle = {
  textAlign: "center",
  color: "white",
  backgroundColor: "transparent",
  border: "none",
  padding: "0",
  margin: "0",
  pointerEvents: "none",
  userSelect: "none",
  overflow: "visible",
  position: "absolute",
  fontFamily: "YageFont"
};
class Text extends UIElement {
  constructor(bounds, config) {
    if (Array.isArray(bounds)) {
      bounds = new Position(bounds[0], bounds[1], { width: 0, height: 0 });
    }
    super(bounds, config, defaultStyle);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClickInternal() {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMouseDownInternal() {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMouseUpInternal() {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onBlurInternal() {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onFocusInternal() {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMouseEnterInternal() {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMouseLeaveInternal() {
  }
  updateInternal(gameModel) {
  }
  handleConfigChange(key, value) {
    if (this.destroyed) {
      return;
    }
    if (key === "label") {
      this._config.label = value;
      if (typeof this._config.label === "string" && value.trim().startsWith("<")) {
        this.element.innerHTML = value;
      } else if (this._config.label === void 0) {
        this.element.innerText = "";
      } else {
        this.element.innerText = value;
      }
      return;
    }
    if (key === "fontSize") {
      this._config.fontSize = value;
      const scales = this.getScales();
      this.element.style.fontSize = `${scaleFont(this.config.fontSize || 12, scales[0] * scales[1] * scales[2])}px`;
      return;
    }
    if (key === "scrollable") {
      this._config.scrollable = value;
      this.element.style.overflow = value ? "auto" : "visible";
      return;
    }
    super.handleConfigChange(key, value);
  }
  _update() {
    super._update();
    if (!this.isVisible()) {
      return;
    }
    const textElement = this.element;
    if (!textElement) {
      return;
    }
    const scales = this.getScales();
    textElement.style.fontSize = `${scaleFont(this.config.fontSize || 12, scales[0] * scales[1] * scales[2])}px`;
    if (typeof this._config.label === "string" && this._config.label.trim().startsWith("<")) {
      textElement.innerHTML = this._config.label;
    } else if (this._config.label === void 0) {
      textElement.innerText = "";
    } else {
      textElement.innerText = this._config.label;
    }
    if (this._config.scrollable) {
      textElement.style.pointerEvents = "auto";
      textElement.style.overflow = "auto";
    }
  }
}
export {
  Text
};
//# sourceMappingURL=Text.js.map
